export type CachedEntry<T> = { v: number; at: number; ttl: number; data: T };

export function cacheKey(tenant: string, name: string, brandVersion?: string) {
    return `${tenant || "_none"}::${name}${brandVersion ? `::${brandVersion}` : ""}`;
}

export function loadCache<T>(key: string): T | null {
    try {
        const raw = localStorage.getItem(key);
        if (!raw) return null;
        const entry = JSON.parse(raw) as CachedEntry<T>;
        if (!entry || typeof entry !== "object") return null;
        if (entry.ttl > 0 && Date.now() - entry.at > entry.ttl) return null;
        return entry.data;
    } catch {
        return null;
    }
}

export function saveCache<T>(key: string, data: T, ttlMs: number, v = 1) {
    try {
        const entry: CachedEntry<T> = { v, at: Date.now(), ttl: ttlMs, data };
        localStorage.setItem(key, JSON.stringify(entry));
    } catch {
        // ignore quota errors
    }
}
